import React from "react";

export const LoaderAI = () => {
  return (
    <div class="loader-wrapper">
      <svg style={{ position: "absolute", width: 0, height: 0 }}>
        <defs>
          <filter id="goo">
            <feGaussianBlur
              in="SourceGraphic"
              stdDeviation="2.5"
              result="blur"
            />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  
                      0 1 0 0 0  
                      0 0 1 0 0  
                      0 0 0 18 -7"
              result="goo"
            />
            <feBlend in="SourceGraphic" in2="goo" />
          </filter>
        </defs>
      </svg>

      <div className="loader-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <circle className="dot-left" cx="10" cy="24" r="4" fill="#9810FA" />
          <circle className="dot-middle" cx="24" cy="24" r="4" fill="#E60076" />
          <circle className="dot-right" cx="38" cy="24" r="4" fill="#155DFC" />
        </svg>
      </div>
    </div>
  );
};
